/**
 * Learn more about theme events at
 * https://help.switchthemes.co/shapes/developer/theme-events/overview.html
 */

window.theme = window.theme || {};

window.theme.events = {
  version: '1.0',
};

document.addEventListener('theme:update:cart', async () => {
  document.dispatchEvent(new CustomEvent('shapes:cart:lock'));

  try {
    const response = await fetch(
      `${window.location.pathname}?sections=cart-items,cart-footer,cart-item-count,cart-live-region`
    );
    const data = await response.json();

    if (!data.status) {
      document.dispatchEvent(
        new CustomEvent('shapes:cart:update', {
          bubbles: true,
          detail: {
            response: {
              sections: {
                ...data,
              },
            },
          },
        })
      );
    }
  } catch (e) {
    console.error(e);
    document.getElementById('cart-errors').textContent =
      theme.strings.cartError;
    document.dispatchEvent(
      new CustomEvent('theme:cart:error:other', {
        detail: {
          message: theme.strings.cartError,
          error: e,
        },
      })
    );
  } finally {
    document.dispatchEvent(new CustomEvent('shapes:cart:unlock'));
  }
});

const getCartDrawerEl = () => {
  return document.querySelector('[data-cart-drawer]');
};

document.addEventListener('cart-will-open', async () => {
  const cartDrawerEl = getCartDrawerEl();

  const detail = {
    cartDrawerEl,
  };

  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:opening', {
      detail,
    })
  );
});

document.addEventListener('cart-is-open', async () => {
  const cartDrawerEl = getCartDrawerEl();

  const detail = {
    cartDrawerEl,
  };

  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:open', {
      detail,
    })
  );
});

document.addEventListener('cart-will-close', () => {
  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:closing', {
      detail: {
        cartDrawerEl: getCartDrawerEl(),
      },
    })
  );
});

document.addEventListener('cart-is-closed', () => {
  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:closed', {
      detail: {
        cartDrawerEl: getCartDrawerEl(),
      },
    })
  );
});

document.addEventListener('theme:open:cart-drawer', () => {
  if (
    window.theme.settings.cart_type === 'modal' &&
    Alpine.store('modals').modals.cart
  ) {
    Alpine.store('modals').closeAll();

    Alpine.store('modals').open('cart');
  }
});

document.addEventListener('theme:close:cart-drawer', () => {
  if (
    window.theme.settings.cart_type === 'modal' &&
    Alpine.store('modals').modals.cart
  ) {
    Alpine.store('modals').close('cart');
  }
});

const cartChangeEventHandler = (e) => {
  const { cartItemCount, itemsRootEl, lineItemEl, variantId, key } = e.detail;

  document.dispatchEvent(
    new CustomEvent('theme:cart:change', {
      detail: {
        type: e.type,
        cartItemCount,
        itemsRootEl,
        lineItemEl,
        variantId,
        key,
        originalDetail: e.detail,
      },
    })
  );
};

document.addEventListener('theme:product:add', cartChangeEventHandler);
document.addEventListener('theme:line-item:change', cartChangeEventHandler);

const cartErrorEventHandler = (e) => {
  document.dispatchEvent(
    new CustomEvent('theme:cart:error', {
      detail: {
        type: e.type,
        message: e.detail.message,
        originalDetail: e.detail,
      },
    })
  );
};

document.addEventListener(
  'theme:product:error:add-to-cart',
  cartErrorEventHandler
);

document.addEventListener('theme:line-item:error', cartErrorEventHandler);
document.addEventListener('theme:cart:error:other', cartErrorEventHandler);

/**
 * Set `window.themeEventsDebugMode` to `true` to log events
 * outside the theme editor
 */

if (Shopify.designMode || window.themeEventsDebugMode) {
  const themeEvents = [
    'theme:variant:change',
    'theme:product:add',
    'theme:line-item:change',
    'theme:cart:change',
    'theme:cart:update',
    'theme:cart-drawer:opening',
    'theme:cart-drawer:open',
    'theme:cart-drawer:closing',
    'theme:cart-drawer:closed',
    'theme:product:error:add-to-cart',
    'theme:line-item:error',
    'theme:cart:error:other',
    'theme:cart:error',
  ];

  const aggregateEvents = ['theme:cart:change', 'theme:cart:error'];

  for (const eventName of themeEvents) {
    let color;

    if (eventName.includes('error')) {
      color = '#ef4444';
    } else {
      color = '#22c55e';
    }

    const message = [
      `%c\u25CF %c${eventName}`,
      `color: ${color};`,
      'font-weight: bold;',
    ];

    if (aggregateEvents.includes(eventName)) {
      document.addEventListener(eventName, (e) => {
        console.groupCollapsed(...message);
        console.log(
          `Underlying event: %c${e.detail.type}`,
          'font-weight: bold;'
        );
        console.log('Event detail:', e.detail);
        console.groupEnd();
      });
    } else {
      document.addEventListener(eventName, (e) => {
        console.log(...message, e.detail);
      });
    }
  }
}

// Custom Logic to fix: "Can't see the items being added to the cart unless you refresh the page"
document.addEventListener('click', async (e) => {

  const addToCartButton = e.target.closest('.htc-add-to-cart-btn');
  if (!addToCartButton) {
    return;
  }

  console.log('Add-to-Cart button found:', addToCartButton);

  e.preventDefault(); // Prevent default behavior (optional)

  try {
    // Extract the variant ID from the onclick attribute
    const onclickAttribute = addToCartButton.getAttribute('onclick');
    const variantId = onclickAttribute.match(/\d+/)?.[0]; // Extract the first number
    if (!variantId) {
      return;
    }

    // Add the item to the cart
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });

    if (response.ok) {      
      // After adding to cart, update the cart count in the Alpine store
      updateCartCountInStore();
      await refreshCart(); // Call the refreshCart function to update cart UI
    }
  } catch (error) {
  }
});

// Function to refresh the cart UI
async function refreshCart() {
  try {
    const response = await fetch(
      `${window.location.pathname}?sections=cart-items,cart-footer,cart-item-count,cart-live-region`
    );
    const data = await response.json();

    // Dispatch an event to update the cart
    document.dispatchEvent(
      new CustomEvent('shapes:cart:update', {
        bubbles: true,
        detail: {
          response: {
            sections: {
              ...data,
            },
          },
        },
      })
    );
  } catch (error) {
  }
}

// Ensure cart store is initialized and update the count
function updateCartCountInStore() {
  try {
    // Ensure the cart store for count is initialized
    if (!Alpine.store('cart_count')) {
      Alpine.store('cart_count', { count: 0 });
    }

    // Get the current count from the cart store
    const cartCountStore = Alpine.store('cart_count');
    const updatedCount = cartCountStore.count + 1; // Increment the count by 1 (new item added)

    // Update the count in the store
    cartCountStore.count = updatedCount;

    // Find the div containing the cart icon
    const cartIconContainer = document.querySelector('.pointer-events-none.relative.my-auto.align-middle');
    if (cartIconContainer) {
      // Check if the cart count span already exists inside this container
      let cartCountElement = cartIconContainer.querySelector('[x-text="$store.cart_count.count"]');
      
      // If the element doesn't exist, create it dynamically inside the container
      if (!cartCountElement) {
        cartCountElement = document.createElement('span');
        cartCountElement.className = "absolute -bottom-1.5 -right-1.5 flex h-5 w-5 items-center justify-center rounded-full bg-scheme-text text-[0.625rem] tracking-normal text-scheme-background";
        cartCountElement.setAttribute("x-show", "$store.cart_count.count > 0");
        cartCountElement.setAttribute("x-text", "$store.cart_count.count");
        cartIconContainer.appendChild(cartCountElement); // Append it inside the cart icon container
      }

      // Update the text content for the cart count element
      cartCountElement.textContent = updatedCount;
    }
  } catch (error) {
  }
}
// Custom Logic End